    document.addEventListener('DOMContentLoaded', function () {
      // GOOGLE SHEETS URL - Replace with your deployed script URL
      const GOOGLE_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbxOF-xqtO9V0evfXByL5-laoFJvhbVe8OeB73Duy_dA2PUzhmXxZciLQId2inATL1ut/exec";

      let currentRowId = null;
      const modalOverlay = document.getElementById('modalOverlay');
      const closeModalBtn = document.getElementById('closeModal');
      const form = document.getElementById('scheduleForm');
      const step1 = document.getElementById('step1');
      const step2 = document.getElementById('step2');
      const prevStep2Btn = document.getElementById('prevStep2');
      const nextStepBtn = document.getElementById('nextStepBtn');
      const submitBtn = document.getElementById('submitBtn');
      const progressSteps = document.querySelectorAll('.progress-step');

      /* -------------------------------------------------
         GA4 Helper – push event only if gtag exists
         ------------------------------------------------- */
      function fireGA(eventName, params = {}) {
        if (typeof gtag === 'function') {
          gtag('event', eventName, params);
          console.log('GA4 event:', eventName, params);
        } else {
          console.warn('gtag not loaded – event not sent:', eventName);
        }
      }

      /* -------------------------------------------------
         Facebook Pixel Helper – push Lead Form event only if fbq exists
         ------------------------------------------------- */
      function fireFacebookLeadEvent(eventType, params = {}) {
        if (typeof fbq === 'function') {
          fbq('trackCustom', eventType, params);
          console.log('Facebook Lead Form event:', eventType, params);
        } else {
          console.warn('fbq not loaded – event not sent:', eventType);
        }
      }

      /* -------------------------------------------------
         Notification / Validation helpers
         ------------------------------------------------- */
      function showNotification(message, type = 'info') {
        const notification = document.createElement('div');
        notification.className = `notification ${type}`;
        notification.textContent = message;
        const container = document.getElementById('notificationContainer');
        if (container) {
          container.appendChild(notification);
          setTimeout(() => notification.classList.add('show'), 100);
          setTimeout(() => {
            notification.classList.remove('show');
            setTimeout(() => notification.remove(), 300);
          }, 4000);
        } else {
          console.log(`${type.toUpperCase()}: ${message}`);
        }
      }

      function showError(fieldId, message) {
        const field = document.getElementById(fieldId);
        const errorElement = document.getElementById(fieldId + 'Error');
        if (field) { field.classList.remove('success'); field.classList.add('error'); }
        errorElement.textContent = message;
        errorElement.className = 'validation-message error';
      }

      function showSuccess(fieldId, message = '') {
        const field = document.getElementById(fieldId);
        const errorElement = document.getElementById(fieldId + 'Error');
        if (field) { field.classList.remove('error'); field.classList.add('success'); }
        if (message) {
          errorElement.textContent = message;
          errorElement.className = 'validation-message success';
        } else {
          errorElement.className = 'validation-message';
        }
      }

      function clearValidation(fieldId) {
        const field = document.getElementById(fieldId);
        const errorElement = document.getElementById(fieldId + 'Error');
        if (field) field.classList.remove('error', 'success');
        errorElement.className = 'validation-message';
      }

      function validatePhone(phone) { return /^[6-9]\d{9}$/.test(phone); }
      function validatePincode(pincode) { return /^[0-9]{6}$/.test(pincode); }

      function validateMaterials() {
        const materials = document.querySelectorAll('input[name="materials"]:checked');
        const materialsError = document.getElementById('materialsError');
        if (materials.length === 0) {
          materialsError.textContent = 'Please select at least one material';
          materialsError.className = 'validation-message error';
          return false;
        } else {
          materialsError.className = 'validation-message success';
          materialsError.textContent = `${materials.length} material(s) selected`;
          return true;
        }
      }

      function validateUserType() {
        const userType = document.querySelector('input[name="userType"]:checked');
        const userTypeError = document.getElementById('userTypeError');
        if (!userType) {
          userTypeError.textContent = 'Please select your role';
          userTypeError.className = 'validation-message error';
          return false;
        } else {
          userTypeError.className = 'validation-message success';
          userTypeError.textContent = '';
          return true;
        }
      }

      function validateProjectType() {
        const projectType = document.getElementById('projectType').value;
        const projectTypeError = document.getElementById('projectTypeError');
        if (!projectType) {
          projectTypeError.textContent = 'Please select project type';
          projectTypeError.className = 'validation-message error';
          return false;
        } else {
          projectTypeError.className = 'validation-message success';
          projectTypeError.textContent = '';
          return true;
        }
      }

      function smoothScrollInModal(element, offset = 20) {
        const modalBody = document.querySelector('.modal-body');
        const elementPos = element.getBoundingClientRect().top;
        const modalPos = modalBody.getBoundingClientRect().top;
        const scrollPos = elementPos - modalPos - offset;
        modalBody.scrollTo({ top: scrollPos, behavior: 'smooth' });
      }

      /* -------------------------------------------------
         SEND DATA TO GOOGLE SHEETS
         ------------------------------------------------- */
      async function saveToGoogleSheets(step, data) {
        try {
          const params = new URLSearchParams({ step: step, ...data });
          await fetch(GOOGLE_SCRIPT_URL + '?' + params.toString(), {
            method: 'GET',
            mode: 'no-cors'
          });
          console.log(`Step ${step} data sent:`, data);
          return true;
        } catch (error) {
          console.error(`Error sending step ${step} data:`, error);
          return false;
        }
      }

      /* -------------------------------------------------
         Input blur / change listeners
         ------------------------------------------------- */
      document.getElementById('name').addEventListener('blur', function () {
        if (!this.value.trim()) showError('name', 'Name is required');
        else if (this.value.trim().length < 2) showError('name', 'Name must be at least 2 characters');
        else showSuccess('name');
      });

      document.getElementById('phone').addEventListener('input', function () {
        this.value = this.value.replace(/[^0-9]/g, '');
        if (this.value.length > 10) this.value = this.value.slice(0, 10);
      });
      document.getElementById('phone').addEventListener('blur', function () {
        if (!this.value.trim()) showError('phone', 'Phone number is required');
        else if (!validatePhone(this.value)) showError('phone', 'Please enter a valid 10-digit phone number');
        else showSuccess('phone');
      });

      document.getElementById('pincode').addEventListener('input', function () {
        this.value = this.value.replace(/[^0-9]/g, '');
        if (this.value.length > 6) this.value = this.value.slice(0, 6);
      });
      document.getElementById('pincode').addEventListener('blur', function () {
        if (!this.value.trim()) showError('pincode', 'Pincode is required');
        else if (!validatePincode(this.value)) showError('pincode', 'Please enter a valid 6-digit pincode');
        else showSuccess('pincode');
      });

      document.querySelectorAll('input[name="materials"]').forEach(cb => cb.addEventListener('change', validateMaterials));
      document.querySelectorAll('input[name="userType"]').forEach(r => r.addEventListener('change', validateUserType));
      document.getElementById('projectType').addEventListener('change', validateProjectType);

      document.querySelectorAll('.radio-option').forEach(opt => {
        opt.addEventListener('click', function () {
          const radio = this.querySelector('input[type="radio"]');
          radio.checked = true;
          document.querySelectorAll('.radio-option').forEach(o => o.classList.remove('selected'));
          this.classList.add('selected');
          validateUserType();
        });
      });

      document.querySelectorAll('.checkbox-option').forEach(opt => {
        opt.addEventListener('click', function () {
          const cb = this.querySelector('input[type="checkbox"]');
          cb.checked = !cb.checked;
          this.classList.toggle('selected');
          if (cb.name === 'materials') validateMaterials();
        });
      });

      /* -------------------------------------------------
         Modal open / close
         ------------------------------------------------- */
      function openModal() {
        modalOverlay.classList.add('active');
        resetForm();
      }
      closeModalBtn.addEventListener('click', () => modalOverlay.classList.remove('active'));
      modalOverlay.addEventListener('click', e => { if (e.target === modalOverlay) modalOverlay.classList.remove('active'); });

      /* -------------------------------------------------
         NEXT BUTTON – Step 1 → Step 2
         ------------------------------------------------- */
      nextStepBtn.addEventListener('click', async function () {
        const name = document.getElementById('name').value.trim();
        const phone = document.getElementById('phone').value.trim();
        let isValid = true;

        if (!name || name.length < 2) { showError('name', 'Name is required (min 2 characters)'); isValid = false; }
        if (!phone || !validatePhone(phone)) { showError('phone', 'Please enter a valid 10-digit phone number'); isValid = false; }

        if (!isValid) {
          showNotification('Please fill all required fields correctly', 'error');
          return;
        }

        const step1Data = {
          name: name,
          phone: phone
        };
        currentRowId = Date.now() + '-' + step1Data.phone;
        step1Data.rowId = currentRowId;

        nextStepBtn.textContent = 'Saving...';
        nextStepBtn.disabled = true;

        const saved = await saveToGoogleSheets('1', step1Data);
        if (saved) {
          /* ==== GA4 EVENT schedule_visit_1 ==== */
          fireGA('schedule_visit_1', {
            row_id: currentRowId,
            name: step1Data.name,
            phone: step1Data.phone
          });

          /* ==== FACEBOOK LEAD FORM EVENT - Step 1 ==== */
          fireFacebookLeadEvent('LeadFormStep1', {
            content_name: 'Schedule Visit - Step 1',
            content_category: 'Contact Info',
            form_step: 1,
            value: 1,
            currency: 'INR'
          });

          step1.classList.remove('active');
          step2.classList.add('active');
          progressSteps[0].classList.remove('active');
          progressSteps[1].classList.add('active');
          setTimeout(() => smoothScrollInModal(step2, 10), 100);
        } else {
          showNotification('Failed to save data. Please try again.', 'error');
        }
        nextStepBtn.textContent = 'Next';
        nextStepBtn.disabled = false;
      });

      /* -------------------------------------------------
         PREVIOUS BUTTON
         ------------------------------------------------- */
      prevStep2Btn.addEventListener('click', function () {
        step2.classList.remove('active');
        step1.classList.add('active');
        progressSteps[1].classList.remove('active');
        progressSteps[0].classList.add('active');
        setTimeout(() => smoothScrollInModal(step1, 10), 100);
      });

      /* -------------------------------------------------
         FORM SUBMIT – Step 2
         ------------------------------------------------- */
      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        let isValid = true;

        if (!validateUserType()) isValid = false;
        if (!validateProjectType()) isValid = false;
        if (!validateMaterials()) isValid = false;

        const pincode = document.getElementById('pincode').value;
        if (!pincode) { showError('pincode', 'Pincode is required'); isValid = false; }
        else if (!validatePincode(pincode)) { showError('pincode', 'Please enter a valid 6-digit pincode'); isValid = false; }

        if (!isValid) {
          showNotification('Please fill all required fields correctly', 'error');
          const firstError = document.querySelector('.validation-message.error');
          if (firstError) setTimeout(() => smoothScrollInModal(firstError, 30), 100);
          return;
        }

        const userType = document.querySelector('input[name="userType"]:checked');
        const projectType = document.getElementById('projectType').value;
        const materials = document.querySelectorAll('input[name="materials"]:checked');

        const step2Data = {
          rowId: currentRowId,
          userType: userType.value,
          projectType: projectType,
          materials: Array.from(materials).map(m => m.value).join(', '),
          pincode: pincode
        };

        submitBtn.textContent = 'Submitting...';
        submitBtn.disabled = true;

        const saved = await saveToGoogleSheets('2', step2Data);
        if (saved) {
          /* ==== GA4 EVENT schedule_visit_2 ==== */
          fireGA('schedule_visit_2', {
            row_id: currentRowId,
            user_type: step2Data.userType,
            project_type: step2Data.projectType,
            materials: step2Data.materials,
            pincode: step2Data.pincode
          });

          /* ==== FACEBOOK LEAD FORM EVENT - Step 2 (Form Completed) ==== */
          fireFacebookLeadEvent('LeadFormCompleted', {
            content_name: 'Schedule Visit - Completed',
            user_type: step2Data.userType,
            project_type: step2Data.projectType,
            form_step: 2,
            value: 10,
            currency: 'INR'
          });

          showNotification('Form submitted successfully! We will contact you soon.', 'success');
          modalOverlay.classList.remove('active');
          resetForm();
        } else {
          showNotification('Failed to submit form. Please try again.', 'error');
        }
        submitBtn.textContent = 'Submit';
        submitBtn.disabled = false;
      });

      /* -------------------------------------------------
         Reset form
         ------------------------------------------------- */
      function resetForm() {
        form.reset();
        step1.classList.add('active');
        step2.classList.remove('active');
        progressSteps[0].classList.add('active');
        progressSteps[1].classList.remove('active');
        currentRowId = null;
        document.querySelectorAll('.validation-message').forEach(el => el.className = 'validation-message');
        document.querySelectorAll('input, select').forEach(el => el.classList.remove('error', 'success'));
        document.querySelectorAll('.radio-option, .checkbox-option').forEach(opt => opt.classList.remove('selected'));
        const modalBody = document.querySelector('.modal-body');
        if (modalBody) modalBody.scrollTop = 0;
      }

      window.openScheduleModal = openModal;
    });